// src/HtmlToPdf.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faCode } from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

function HtmlToPdf() {
  const [htmlCode, setHtmlCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleHtmlCodeChange = (event) => {
    setHtmlCode(event.target.value);
  };

  const convertHtmlToPdf = async () => {
    if (!htmlCode) return;

    setLoading(true);
    setError(null);

    try {
      const pdf = new jsPDF();
      const element = document.createElement('div');
      element.innerHTML = htmlCode;
      document.body.appendChild(element);

      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', 0, 0);
      pdf.save('document.pdf');

      document.body.removeChild(element);
    } catch (err) {
      setError('An error occurred while converting HTML to PDF.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="html-to-pdf">
      <h2>HTML to PDF</h2>
      <textarea
        value={htmlCode}
        onChange={handleHtmlCodeChange}
        placeholder="Enter HTML code here"
        rows="10"
        cols="50"
      />
      <button onClick={convertHtmlToPdf} disabled={loading} className="convert-button">
        <FontAwesomeIcon icon={faFilePdf} /> Convert to PDF
      </button>
      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}
    </div>
  );
}

export default HtmlToPdf;
